import { render } from "./ChefDeMarche.vue?vue&type=template&id=8bf9f3ea"
import script from "./ChefDeMarche.vue?vue&type=script&lang=js"
export * from "./ChefDeMarche.vue?vue&type=script&lang=js"

import "./ChefDeMarche.vue?vue&type=style&index=0&id=8bf9f3ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__